export default __webpack_public_path__ + "static/training-f5781dbbd8cdbce8bfb85f241ea6828f.png";